<template>
  <div class="left-top-right-list">
    <div style="position: relative">
      <titleInternal v-if="tabPosition != 'left'" titleName="处置效率分析"></titleInternal>
      <titleInternal v-else titleName="今日处置效率分析"></titleInternal>
      <el-radio-group
        v-model="tabPosition"
        style="margin-bottom: 30px"
        @input="inputChange"
        class="special-radio"
        size="mini"
      >
        <el-radio-button label="top">上报问题</el-radio-button>
        <el-radio-button label="left">长期巡查</el-radio-button>
        <el-radio-button label="bottom">孤寡老人巡查</el-radio-button>
      </el-radio-group>
    </div>

    <div v-if="tabPosition == 'top'">
      <baseDisplay :baseDataList="baseDataList"></baseDisplay>
      <div class="ranking">
        <div
          class="ranking-cont"
          :class="'top' + index"
          v-for="(item, index) in componentDataOne"
          :key="index"
        >
          <div class="flex-just" style="margin-bottom: 12px">
            <div class="ranking-number">
              <img
                :src="
                  require(`@/assets/daping/img-paiming${index > 3 ? 4 : index + 1}.svg`)
                "
              />
              <span :class="['number', index < 9 ? 'numberOne' : 'numberTwo']">{{ index + 1 }}</span>
              <div class="ranking-name">{{ item.communityName }}</div>
            </div>
            <div class="ranking-count">
              {{ item.questionCompleteCount }}/{{ item.questionCount }}
            </div>
          </div>

          <div class="ranking-content">
            <div class="ranking-total">
              <div class="flex rankingPosition">
                <div
                  v-if="item.questionCount == 0"
                  class="ranking-countOne"
                  :style="{
                    width: '0%',
                  }"
                ></div>
                <div
                  v-else
                  class="ranking-countOne"
                  :style="{
                    width: (item.questionCompleteCount / item.questionCount) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div>
              <!-- <div class="flex rankingPosition">
                <div
                  class="ranking-countTwo"
                  :style="{
                    width: (item.count / (item.count1 + item.count)) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabPosition == 'left'">
      <baseDisplay :baseDataList="baseDataLeftList"></baseDisplay>
      <div class="ranking rankingTwo">
        <div
          class="ranking-cont"
          :class="'top' + index"
          v-for="(item, index) in componentDataTwo"
          :key="index"
        >
          <div class="flex-just" style="margin-bottom: 12px">
            <div class="ranking-number">
              <img
                :src="
                  require(`@/assets/daping/img-paiming${index > 3 ? 4 : index + 1}.svg`)
                "
              />
              <span :class="['number', index < 9 ? 'numberOne' : 'numberTwo']">{{ index + 1 }}</span>
              <div class="ranking-name">{{ item.communityName }}</div>
            </div>
            <div class="ranking-count">
              {{ item.longPatrolCompleteCount }}/{{ item.longPatrolCount }}
            </div>
          </div>

          <div class="ranking-content">
            <div class="ranking-total">
              <div class="flex rankingPosition">
                <div
                  v-if="item.longPatrolCount == 0"
                  class="ranking-countOne"
                  :style="{
                    width: '0%',
                  }"
                ></div>
                <div
                  v-else
                  class="ranking-countOne"
                  :style="{
                    width:
                      (item.longPatrolCompleteCount / item.longPatrolCount) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div>
              <!-- <div class="flex rankingPosition">
                <div
                  class="ranking-countTwo"
                  :style="{
                    width: (item.count / (item.count1 + item.count)) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabPosition == 'bottom'">
      <baseDisplay :baseDataList="baseDataBottomList"></baseDisplay>
      <div class="ranking rankingTwo">
        <div
          class="ranking-cont"
          :class="'top' + index"
          v-for="(item, index) in componentDataThree"
          :key="index"
        >
          <div class="flex-just" style="margin-bottom: 12px">
            <div class="ranking-number">
              <img
                :src="
                  require(`@/assets/daping/img-paiming${index > 3 ? 4 : index + 1}.svg`)
                "
              />
              <span :class="['number', index < 9 ? 'numberOne' : 'numberTwo']">{{ index + 1 }}</span>
              <div class="ranking-name">{{ item.communityName }}</div>
            </div>
            <div class="ranking-count">{{ item.oldPeopleCompleteCount }}/{{ item.oldPeopleCount }}</div>
          </div>

          <div class="ranking-content">
            <div class="ranking-total">
              <div class="flex rankingPosition">
                <div
                  class="ranking-countOne"
                  :style="{
                    width: (item.oldPeopleCompleteCount / (item.oldPeopleCount)) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div>
              <!-- <div class="flex rankingPosition">
                <div
                  class="ranking-countTwo"
                  :style="{
                    width: (item.count / (item.count1 + item.count)) * 100 + '%',
                  }"
                ></div>
                <div class="ranking-countBlack"></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
import baseDisplay from "@/pages/patrolScreenMini/components/base-displaySpecail.vue";
import { getResourceDisposalByType } from "@/api/daping.js";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
    baseDisplay,
  },
  data() {
    return {
      baseDataList: [
        {
          img: require("@/assets/daping/wts.png"),
          name: "问题数/个",
          num: 0,
          key: "questionCount",
        },
        {
          img: require("@/assets/daping/bjs.png"),
          name: "办结数/个",
          num: 0,
          key: "questionCompleteCount",
        },
        {
          img: require("@/assets/daping/bjl.png"),
          name: "办结率",
          num: "0%",
          key: "questionCompleteRate",
        },
      ],
      baseDataLeftList: [
        {
          img: require("@/assets/daping/cqxc1.png"),
          name: "任务数/个",
          num: 0,
          key: "longPatrolCount",
        },
        {
          img: require("@/assets/daping/cqxc2.png"),
          name: "子任务数/个",
          num: 0,
          key: "longPatrolChildCount",
        },
        {
          img: require("@/assets/daping/cqxc3.png"),
          name: "巡查数",
          num: 0,
          key: "longPatrolCompleteCount",
        },
        {
          img: require("@/assets/daping/bjl.png"),
          name: "巡查率",
          num: "0%",
          key: "longPatrolCompleteRate",
        },
      ],
      baseDataBottomList: [
        {
          img: require("@/assets/daping/gglr1.png"),
          name: "规定任务数/个",
          num: 0,
          key: "oldPeopleCount",
        },
        {
          img: require("@/assets/daping/gglr2.png"),
          name: "主动上报数/个",
          num: 0,
          key: "oldPeopleProactivelyReportCount",
        },
        {
          img: require("@/assets/daping/cqxc3.png"),
          name: "巡查记录数/次",
          num: 0,
          key: "oldPeopleCompleteCount",
        },
        {
          img: require("@/assets/daping/bjl.png"),
          name: "巡查率",
          num: 0,
          key: "oldPeopleCompleteRate",
        },
      ],
      tabPosition: "top",
      componentDataOne: [],
      componentDataTwo: [],
      componentDataThree: [],
    };
  },
  mounted() {
    this.getResourceDisposalByType(1);
    this.getResourceDisposalByType(2);
    this.getResourceDisposalByType(3);
  },
  methods: {
    inputChange(val) {
      this.getResourceDisposalByType(val == "top" ? 1 : val == "left" ? 2 : 3);
    },
    async getResourceDisposalByType(type) {
      let res = await getResourceDisposalByType({
        type: type,
      });
      if (res.data.code == 200) {
        console.log(res.data.data, 888);
        if (type == 1) {
          this.baseDataList.forEach((item) => {
            if (item.key == "questionCompleteRate") {
              item.num =
                res.data.data[item.key] > 0 ? (res.data.data[item.key] * 100).toFixed(0) + "%" : "0%";
            } else {
              item.num = res.data.data[item.key];
            }
          });
          this.componentDataOne = res.data.data.questionStatisticsList;
        } else if (type == 2) {
          this.baseDataLeftList.forEach((item) => {
            if (item.key == "longPatrolCompleteRate") {
              item.num =
                res.data.data[item.key] > 0 ? (res.data.data[item.key] * 100).toFixed(0) + "%" : "0%";
            } else {
              item.num = res.data.data[item.key];
            }
          });
          this.componentDataTwo = res.data.data.longPatrolStatisticsList;
        } else {
          this.baseDataBottomList.forEach((item) => {
            if (item.key == "oldPeopleCompleteRate") {
              item.num =
                res.data.data[item.key] > 0 ? (res.data.data[item.key] * 100).toFixed(0) + "%" : "0%";
            } else {
              item.num = res.data.data[item.key];
            }
          });
          this.componentDataThree = res.data.data.oldPeopleStatisticsList
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.left-top-right-list {
  width: 403px;
  height: 423px;
  background: linear-gradient(0deg, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  padding-top: 4px;
}

.special-radio {
  position: absolute;
  top: 10px;
  right: 12px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
    padding: 4px 6px;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
    padding: 4px 6px;
  }
}

.ranking-cont {
  .ranking-number {
    position: relative;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
    .number {
      font-family: MiSans Demibold;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      position: absolute;
      top: 4px;
      left: 8px;
    }
    .numberTwo {
      left: 4px;
    }
    .ranking-name {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 14px;
      color: #f3f8ff;
      margin-left: 10px;
    }
  }
  .ranking-count {
    font-family: MiSans, MiSans;
    font-weight: 500;
    font-size: 14px;
    color: #e4f2ff;
  }
}

.flex-just {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.ranking {
  // background: linear-gradient(0deg, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  width: 403px;
  height: 306px;
  margin-top: 10px;
  padding: 16px 14px;
  overflow-y: auto;
  .ranking-total {
    width: 375px;
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    margin-bottom: 20px;
    position: relative;
  }
  .ranking-countOne {
    background: linear-gradient(90deg, rgba(247, 180, 103, 0) 0%, #f7b467 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
  .ranking-countBlack {
    width: 3px;
    height: 6px;
    background: #e1f4ff;
    box-shadow: 0px 0px 9px 2px rgba(135, 212, 255, 0.7);
  }
  .ranking-countTwo {
    background: linear-gradient(90deg, rgba(0, 163, 255, 0) 0%, #00a3ff 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
}
.rankingTwo {
  height: 250px;
}
.rankingPosition {
  width: 375px;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/left/left-top-right.vue